// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveLearningMaterialList_wrapper__ALhMC","buttonWrapper":"ActiveLearningMaterialList_buttonWrapper__t_0L7"};